import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3361b00b&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3361b00b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3361b00b')) {
      api.createRecord('3361b00b', component.options)
    } else {
      api.reload('3361b00b', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=3361b00b&scoped=true", function () {
      api.rerender('3361b00b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/investment-stategy-manager/Index.vue"
export default component.exports